import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate, SwPush } from '@angular/service-worker';
import { BehaviorSubject, filter } from 'rxjs';
import { CommonService } from '../core/services/common.service';
import { selectRouter } from '../store/selectors/shared.selector';

@Injectable({
  providedIn: 'root'
})
export class SwService {

  private onlineStatus$ = new BehaviorSubject<boolean>(navigator.onLine);
  reDirectPrevRoute:string;
  constructor(
    private swUpdate: SwUpdate,
    private swPush: SwPush,
    private router: Router,
    private commonService: CommonService,
  ) {
    this.getRouter()
    // STEP 1: Subscribe to version updates only once
    this.listenToUpdates();
    this.listenForConnectivityChanges();
    // STEP 2: On each route change, manually check for updates
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkForUpdateOnly(); // Only check, don't activate here
      });
  }

  private listenForConnectivityChanges() {
    // Listen for offline
    window?.addEventListener('offline', () => {
      this.onlineStatus$.next(false);
      this.commonService.router.navigate(['/serverDown']); // 👈 Your offline route
    });

    // Listen for online (optional, in case you want to auto-redirect back)
    window?.addEventListener('online', () => {
      this.onlineStatus$.next(true);
      this.commonService.router.navigate([this.reDirectPrevRoute || '/'])
      // Optional: Navigate to home or refresh page
      // this.router.navigate(['/']); 
    });
  }

  private listenToUpdates() {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.activateAndReload();
      }
    });
  }

  private async checkForUpdateOnly() {
    try {
      await this.swUpdate.checkForUpdate();
    } catch (error) {
      console.error('Error checking for update', error);
    }
  }

  private async activateAndReload() {
    try {
      await this.swUpdate.activateUpdate();
      document.location.reload();
    } catch (error) {
      console.error('Error activating update', error);
    }
  }

  // Push notifications methods
  public subscribeToPush(serverPublicKey: string) {
    if (this.swPush.isEnabled) {
      this.swPush.requestSubscription({
        serverPublicKey: serverPublicKey
      })
        .then(sub => {
          // Send subscription to server
          console.log('Push subscription:', sub);
        })
        .catch(err => console.error('Could not subscribe to notifications', err));
    }
  }

  public listenForNotifications() {
    if (this.swPush.isEnabled) {
      this.swPush.messages.subscribe(
        message => console.log('Received push message', message)
      );

      this.swPush.notificationClicks.subscribe(
        click => console.log('Notification clicked', click)
      );
    }
  }

  // Cache management
  public clearCache() {
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  }

  public isOnline(): boolean {
    return this.onlineStatus$.value;
  }

  public getOnlineStatus() {
    return this.onlineStatus$.asObservable();
  }

  getRouter() {
      this.commonService.store.select(selectRouter).subscribe((res:any) =>{        
        this.reDirectPrevRoute = res[res.length-2]
      })
    }
}